var IS_PURE=require('../internals/is-pure');var getIterator=require('../internals/get-iterator');module.exports=IS_PURE?getIterator:function(it){// eslint-disable-next-line no-undef
return Map.prototype.entries.call(it);};